module.exports = __webpack_public_path__ + "static/media/customerServiceimg3.c4d6964d.png";